"use strict" ;

import Receiver from '../../../system/signals/Receiver'
import logger from '../../logging/logger'

/**
 * This controller is invoked when a state is inserted in the state model.
 * @name AddState
 * @class
 * @memberof molecule.states.controllers
 * @constructor
 */
export default function AddState() {}

AddState.prototype = Object.create( Receiver.prototype ,
{
    constructor : { value : AddState } ,

    /**
     * Receive a message from a state model.
     * @name receive
     * @memberof molecule.states.controllers.AddState
     * @instance
     * @function
     */
    receive : { value : function ( state )
    {
        logger.debug( this + " receive : " + state ) ;
    }}
});